export const generateCorrelationId = (): string =>
  Math.random().toString(36).substring(2, 9)
